const theme = {
  colorGrey: '#444',
  colorLightGrey: '#aaa',
  colorWhiteGrey: '#ddd',
  primaryRed: '#c54242',
  secondaryRed: '#bd7272',
}

export default theme